<template>
  <div class="rstrip">
    <h5 class="rstrip__title">From workshop to plinth · 3,000 nautical miles by sea and river</h5>
    <div class="rstrip__track">
      <div class="rstrip__line" aria-hidden="true"></div>
      <div class="rstrip__stop" v-for="(s, i) in stops" :key="i">
        <div class="rstrip__dot" :class="{ 'is-end': i === 0 || i === stops.length - 1 }">{{ i + 1 }}</div>
        <div class="rstrip__label">{{ s.label }}</div>
        <div class="rstrip__sub">{{ s.sub || ' ' }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const stops = [
  { label: 'Marina di Carrara', sub: 'Aug 1986' },
  { label: 'Mediterranean',     sub: '' },
  { label: 'Gibraltar',         sub: '' },
  { label: 'North Sea',         sub: '' },
  { label: 'Rotterdam',         sub: '2 Sept 1986' },
  { label: 'Rhine',             sub: '' },
  { label: 'Main',              sub: '' },
  { label: 'Frankfurt',         sub: '7 Sept 1986' },
];
</script>

<style scoped>
.rstrip {
  padding: 1.4rem 1.6rem 1.6rem;
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid var(--vein);
  border-radius: 4px;
}
.rstrip__title {
  font-family: var(--font-body);
  font-size: 1.15rem;
  font-weight: 700;
  margin: 0 0 1.8rem;
  color: var(--slate);
  letter-spacing: -0.005em;
}
.rstrip__track {
  position: relative;
  display: flex;
  align-items: flex-start;
  padding-top: 0.6rem;
}
.rstrip__line {
  position: absolute;
  /* The line sits at the dot vertical centre.
     Dot is 28px tall with 2px border, starts at 0.6rem from track top. */
  top: calc(0.6rem + 14px - 1px);
  /* And horizontally it stretches from the centre of the first stop to the
     centre of the last stop, i.e. half a stop-width in from each side. */
  left: calc(100% / 16);
  right: calc(100% / 16);
  height: 2px;
  background: var(--accent);
  z-index: 0;
}
.rstrip__stop {
  position: relative;
  z-index: 1;
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.35rem;
}
.rstrip__dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--paper);
  border: 2px solid var(--accent);
  color: var(--accent-deep);
  font-family: var(--font-body);
  font-weight: 700;
  font-size: 0.78rem;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.rstrip__dot.is-end {
  background: var(--accent);
  color: var(--paper);
}
.rstrip__label {
  font-family: var(--font-body);
  font-size: 0.94rem;
  font-weight: 700;
  color: var(--slate);
  line-height: 1.2;
  margin-top: 0.2rem;
}
.rstrip__sub {
  font-size: 0.72rem;
  color: var(--granite);
  font-style: italic;
  line-height: 1.2;
}
@media (max-width: 760px) {
  .rstrip__track {
    flex-wrap: wrap;
    row-gap: 1rem;
  }
  .rstrip__line { display: none; }
  .rstrip__stop { flex: 1 1 25%; }
}
</style>
